import type { TVariant } from "~/lib/shopify/serializers/serialize-variants"
import { objectEntries } from "~/utils/object-entries"
import { objectValues } from "~/utils/object-values"

export function findVariantFromSelectedOptions(
  selectedOptions: Record<string, string>,
  variants: TVariant[]
): TVariant | undefined {
  const selectedOptionsValues = objectValues(selectedOptions)

  const joinedSelectedOptions = selectedOptionsValues.join(",").replaceAll(" / ", ",")

  const foundVariant = variants.find((variant) => {
    if (!variant.selectedOptions || !selectedOptions) {
      return false
    }

    objectEntries(selectedOptions)?.forEach(([key, value]) => {
      variant?.selectedOptions?.forEach((option) => {
        if (option.name === key && option.value !== value) {
          return false
        }
      })
    })

    const joinedVariantOptions = variant.selectedOptions?.map(({ value }) => value).join(",")

    return joinedVariantOptions === joinedSelectedOptions
  })

  return foundVariant ?? variants?.[0]
}
